/**
 * API 响应解析工具 - 统一 list/total 等结构
 */
import { DEFAULT_PAGE_SIZE } from '@/constants/api';

/** 分页响应 */
export interface PaginatedResponse<T> {
  list: T[];
  total: number;
}

/** 解析 list 响应 */
export function parseListResponse<T = unknown>(d: unknown): T[] {
  const obj = d as { list?: unknown } | null | undefined;
  if (obj?.list != null && Array.isArray(obj.list)) return obj.list as T[];
  return [];
}

/** 解析分页响应 */
export function parsePaginatedResponse<T = unknown>(d: unknown): PaginatedResponse<T> {
  const obj = d as { list?: unknown; total?: number } | null | undefined;
  return {
    list: Array.isArray(obj?.list) ? (obj.list as T[]) : [],
    total: typeof obj?.total === 'number' ? obj.total : 0,
  };
}

/** 分页响应（含 page、per_page、可选 server_time 用于增量轮询水位） */
export interface PaginatedResponseFull<T> extends PaginatedResponse<T> {
  page: number;
  per_page: number;
  server_time?: string;
}

/** 解析完整分页响应 */
export function parsePaginatedResponseFull<T = unknown>(
  d: unknown,
  defaults = { page: 1, per_page: DEFAULT_PAGE_SIZE },
): PaginatedResponseFull<T> {
  const obj = d as
    | {
        list?: unknown;
        total?: number;
        page?: number;
        per_page?: number;
        server_time?: string;
      }
    | null
    | undefined;
  return {
    list: Array.isArray(obj?.list) ? (obj.list as T[]) : [],
    total: typeof obj?.total === 'number' ? obj.total : 0,
    page: typeof obj?.page === 'number' ? obj.page : defaults.page,
    per_page: typeof obj?.per_page === 'number' ? obj.per_page : defaults.per_page,
    ...(typeof obj?.server_time === 'string' ? { server_time: obj.server_time } : {}),
  };
}
